import * as Yup from 'yup';

const isLocal = (val) => val === 'Singapore Citizen' || val === 'Singapore PR';
const isEmployed = (val) => val === 1 || val === 2;

const RegistrationSchema = Yup.object().shape({
  citizenship: Yup.string().required('Required'),
  programme: Yup.string().when('alumni', {
    is: true,
    then: Yup.string().required('Required'),
  }),
  programme_year: Yup.string().when('alumni', {
    is: true,
    then: Yup.string().required('Required'),
  }),
  salutation: Yup.string().required('Required'),
  name: Yup.string().required('Required'),
  nric: Yup.string().when('citizenship', {
    is: (val) => isLocal(val),
    then: Yup.string()
      .required('Required')
      .matches(/^[STFG]\d{7}[A-Z]$/, {
        message: 'must be a valid NRIC',
        excludeEmptyString: true,
      }),
  }),
  nric_colour: Yup.string().when('citizenship', {
    is: (val) => isLocal(val),
    then: Yup.string().required('Required'),
  }),
  home_address: Yup.string().required('Required'),
  email: Yup.string()
    .email()
    .required('Required'),
  contact_no: Yup.string()
    .min(5, 'Mobile No must be at least 5 characters')
    .max(20, 'Mobile No must not be greater than 20 characters')
    .required('Required')
    .matches(/^\d+$/, {
      message: 'must be numeric',
      excludeEmptyString: true,
    }),
  gender: Yup.string().required('Required'),
  race: Yup.string().required('Required'),
  date_of_birth: Yup.string().required('Required'),
  emergency_contact_no: Yup.string()
    .min(5, 'Contact No must be at least 5 characters')
    .max(20, 'Contact No must not be greater than 20 characters')
    .matches(/^\d+$/, {
      message: 'must be numeric',
      excludeEmptyString: true,
    }),
  employed: Yup.number().when('citizenship', {
    is: (val) => isLocal(val),
    then: Yup.number().required('Required'),
  }),
  company_name: Yup.string().when('employed', {
    is: (val) => isEmployed(val),
    then: Yup.string().required('Required'),
  }),
  job_title: Yup.string().when('employed', {
    is: (val) => isEmployed(val),
    then: Yup.string().required('Required'),
  }),
  hear_about: Yup.string().required('Required'),
  hear_about_other: Yup.string().when('hear_about', {
    is: 'Others',
    then: Yup.string().required('Required'),
  }),
  payment_method: Yup.string().required('Required'),
  sponsorship: Yup.number().required('Required'),
  tag_preferred_name: Yup.string().required('Required'),
  pdpa: Yup.bool().oneOf([true], 'Required'),
  //
  billing_contact_salutation: Yup.string().when('sponsorship', {
    is: 1,
    then: Yup.string().required('Required'),
  }),
  billing_contact_first_name: Yup.string().when('sponsorship', {
    is: 1,
    then: Yup.string().required('Required'),
  }),
  billing_contact_last_name: Yup.string().when('sponsorship', {
    is: 1,
    then: Yup.string().required('Required'),
  }),
  billing_contact_company: Yup.string().when('sponsorship', {
    is: 1,
    then: Yup.string().required('Required'),
  }),
  billing_contact_job_title: Yup.string().when('sponsorship', {
    is: 1,
    then: Yup.string().required('Required'),
  }),
  billing_contact_email: Yup.string().when('sponsorship', {
    is: 1,
    then: Yup.string().required('Required'),
  }),
  billing_contact_no: Yup.string()
    .when('sponsorship', {
      is: 1,
      then: Yup.string().required('Required'),
    })
    .min(5, 'Contact No must be at least 5 characters')
    .max(20, 'Contact No must not be greater than 20 characters')
    .matches(/^\d+$/, {
      message: 'must be numeric',
      excludeEmptyString: true,
    }),
  billing_address: Yup.string().when('sponsorship', {
    is: 1,
    then: Yup.string().required('Required'),
  }),
});

export default RegistrationSchema;
